// Roles soportados en auth
const Role = Object.freeze({
  BUYER: 'comprador',
  SELLER: 'vendedor',
  ADMIN: 'administrador',
  CLUB_ADMIN: 'administrador_clubes',
  APP_VALIDATION_ADMIN: 'administrador_app_validacion',
  TICKET_VALIDATOR: 'validador_entradas'
});

// Labels para UI (ES)
const RoleLabels = Object.freeze({
  [Role.BUYER]: 'Comprador',
  [Role.SELLER]: 'Vendedor',
  [Role.ADMIN]: 'Superadministrador',
  [Role.CLUB_ADMIN]: 'Administrador de clubes',
  [Role.APP_VALIDATION_ADMIN]: 'Administrador de app de validacion',
  [Role.TICKET_VALIDATOR]: 'Validador de entradas',
});

(function exposeGlobals() {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      Role,
      RoleLabels
    }
  } else if (typeof window !== 'undefined') {
    window.Role = Role;
    window.RoleLabels = RoleLabels;
  }
})();
